import { Building2, Share2 } from 'lucide-react';

export interface OrigemBadgeData {
  origem?: string | null;
  escritorio_nome?: string | null;
  compartilhado_por?: string | null;
}

/**
 * Badge de origem para recursos (documentos, modelos, etc.).
 * Exibe "Escritório", "Compartilhado", "Sistema" ou nada (pessoal/null).
 */
export function OrigemBadge({ item }: { item: OrigemBadgeData }) {
  if (!item.origem || item.origem === 'pessoal') return null;

  if (item.origem === 'sistema') {
    return (
      <span className="inline-flex items-center gap-1 text-[11px] px-1.5 py-0.5 rounded bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400">
        Sistema
      </span>
    );
  }

  if (item.origem === 'escritorio') {
    return (
      <span className="inline-flex items-center gap-1 text-[11px] px-1.5 py-0.5 rounded bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400">
        <Building2 className="h-2.5 w-2.5" />
        {item.escritorio_nome || 'Escritório'}
      </span>
    );
  }

  if (item.origem === 'compartilhado') {
    return (
      <span className="inline-flex items-center gap-1 text-[11px] px-1.5 py-0.5 rounded bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400">
        <Share2 className="h-2.5 w-2.5" />
        {item.compartilhado_por ? `De ${item.compartilhado_por}` : 'Compartilhado'}
      </span>
    );
  }

  return null;
}
